import React from "react";
import "../styles/ShortInterestStats.scss";

function ShortInterestStats(props) {
  return (
    <div
      className="short-interest-stats"
      style={{
        background:
          props.chartDisplay === "Short-Interest-Chart" ? "#171717" : null,
        padding: "10px 10px 21px 10px",
      }}
    >
      <div className="stats-title justify-center">SHORT INTEREST STATS</div>
      <div className="table-title justify-center">Short Interest</div>

      <div className="equity-text justify-center" style={{ color: "#BBB8B8" }}>
        % Equity Float (
        {props.original.short_int_date
          ? new Date(
              new Date(props.original.short_int_date).setDate(
                new Date(props.original.short_int_date).getDate() + 1 > 14
                  ? 15
                  : 1,
              ),
            ).toLocaleDateString()
          : "N/A"}
        )
      </div>
      <div
        className={
          props.original.si_percent_equity_float
            ? props.original.si_percent_equity_float[0] === "-"
              ? "justify-center short-interest-value red"
              : "justify-center short-interest-value green"
            : "justify-center short-interest-value empty-value"
        }
      >
        {props.original.si_percent_equity_float ? (
          <span>
            {parseFloat(
              props.original.si_percent_equity_float.slice(0, -1),
            ).toFixed(2)}
            %
          </span>
        ) : (
          <span>- - -</span>
        )}
      </div>
      <div className="table-title justify-center">
        % Change in # Shares Short
      </div>
      {/* <div className='stats-table '> */}
      {/* <div className='info '>
          <div className='equity-text justify-center'>vs. last Period</div>
          <div className='equity-text justify-center'>(10/15/20)</div>
          <div className='value justify-center red'>
            {" "}
            <span style={{ color: "hsla(60, 100%, 50%, 1)" }}>NO DATA</span>
          </div>
        </div> */}
      <div className="equity-text justify-center" style={{ color: "#BBB8B8" }}>
        vs. Last Period (
        {props.original.short_int_date
          ? new Date(
              new Date(props.original.short_int_date).setDate(
                new Date(props.original.short_int_date).getDate() + 1 > 14
                  ? 15
                  : 1,
              ),
            ).toLocaleDateString()
          : "N/A"}
        )
      </div>
      <div
        className={
          !props.original.short_int_pct_chg
            ? "justify-center short-interest-value empty-value"
            : props.original.short_int_pct_chg.includes("-")
            ? "justify-center short-interest-value red"
            : "justify-center short-interest-value green"
        }
      >
        {props.original.short_int_pct_chg ? (
          <span> {props.original.short_int_pct_chg}</span>
        ) : (
          <span>- - -</span>
        )}
      </div>
      {/* </div> */}
    </div>
  );
}
export default React.memo(ShortInterestStats);
